import React from 'react';
import { Input, Select, Cascader } from 'antd';
import { SettingOutlined } from '@ant-design/icons';

const SIZE_TO_CLASS_MAP = {
  medium: 'custom-input-medium',
  large: 'custom-input-large',
};

const CustomInputField = (props) => {

    const {size = 'medium', disabled, status, addonBefore, addonAfter, suffix, className, isSelectPrefixOrSuffix = false} = props

    return(
  <div>
    <Input
      {...props}
      disabled={disabled}
      addonBefore={addonBefore}
      addonAfter={addonAfter}
      suffix={suffix}
      className={`${className} 
                    custom-input 
                    ${SIZE_TO_CLASS_MAP[size]} 
                    ${status === 'error' ? 'custom-input-error' : ''} 
                    ${addonAfter && !isSelectPrefixOrSuffix ? 'input-with-suffix' : ''} 
                    ${addonBefore && !isSelectPrefixOrSuffix? 'input-with-prefix': ''}
                    ${isSelectPrefixOrSuffix? 'input-with-select': ''}`
                }
    />
  </div>
    )
};

export default CustomInputField;
